import React from "react";

// Si una página falla al pintarse, se muestra un aviso con «Recargar» en vez de dejar la web en
// blanco. Si el fallo es un archivo de la versión anterior que ya no existe (tras publicar), se
// recarga sola una vez.
const RELOAD_KEY = "ulture_reloaded_after_error";
const isChunkError = (e: unknown) =>
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk/i.test(
    String((e as { message?: string })?.message || e),
  );

const COPY: Record<string, { title: string; reload: string; home: string }> = {
  es: { title: "Algo ha fallado al cargar esta página.", reload: "Recargar", home: "Ir al inicio" },
  en: { title: "Something went wrong loading this page.", reload: "Reload", home: "Go to the home page" },
};

export default class AppErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: unknown }> {
  state = { error: null as unknown };

  static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  componentDidCatch(error: unknown) {
    console.error("App error:", error);
    if (isChunkError(error)) {
      try {
        if (!sessionStorage.getItem(RELOAD_KEY)) {
          sessionStorage.setItem(RELOAD_KEY, "1");
          window.location.reload();
        }
      } catch {
        /* sin sessionStorage */
      }
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    const lang = (typeof navigator !== "undefined" && navigator.language || "es").slice(0, 2) === "es" ? "es" : "en";
    const c = COPY[lang];
    return (
      <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "#fff", fontFamily: "system-ui, sans-serif" }}>
        <div style={{ textAlign: "center", maxWidth: 420 }}>
          <p style={{ fontSize: 18, fontWeight: 600, color: "#0B1B28", margin: "0 0 18px" }}>{c.title}</p>
          <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{ height: 44, padding: "0 22px", borderRadius: 99, border: 0, background: "linear-gradient(100deg,#16C2A6,#0B88C4)", color: "#fff", fontWeight: 600, cursor: "pointer" }}
            >
              {c.reload}
            </button>
            <a href="/" style={{ height: 44, padding: "0 22px", borderRadius: 99, border: "1px solid #DCE5EE", display: "inline-flex", alignItems: "center", color: "#0B1B28", fontWeight: 600, textDecoration: "none" }}>
              {c.home}
            </a>
          </div>
        </div>
      </main>
    );
  }
}
